import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const DriverUtils = {
  driver(options: any) {
    const driverOptions = {
      allowClose: false,
      onHighlighted: () => {
        if (!scroll) document.body.style.overflow = "hidden";
      },
      onDeselected: () => {
        if (!scroll) document.body.style.removeProperty("overflow");
      },
    };
    Object.assign(driverOptions, options);
    driver(driverOptions).drive();
  },
};

export default DriverUtils;
